export default "__VITE_PUBLIC_ASSET__cd4c7c5b__"